/**
 * @Author chenguanbin
 * @Date 2020-03-19 19:40:48
 * @Desc 公共工具类
 */

/**
 * @author chenguanbin
 * @date 2020-03-18 20:35:14
 * @desc 平级结构转化为树形结构
 * TODO: 目前只转了2级，若数据更复杂，需要修改代码
 */
export const formatData2Tree = data => {
  let root = {}
  const unroot = []
  let hasParent = false
  data.forEach(item => {
    if (data.some(a => a.id === item.pId)) {
      unroot.push(item)
      hasParent = true
    } else {
      root = item
    }
  })

  return !hasParent
    ? data
    : [
        {
          ...root,
          children: unroot.length ? unroot : null
        }
      ]
}
/**
 * @Author maogangfeng
 * @Date 2020-03-26 21:19:39
 * @Desc 判断是否存在
 */
export const isUndef = v => {
  return v === undefined || v === null
}

/**
 * @Author: maogangfeng
 * @Date: 2020-03-26 21:14:39
 * @Desc: 格式化两位小数
 */
export const formatWithTwoDecimal = num => {
  return Number(num).toFixed(2)
}
/**
 * @Author maogangfeng
 * @Date 2020-04-01 09:05:22
 * @Desc 函数防抖
 */
export function _debounce(fn, delayOpt) {
  const delay = delayOpt || 500
  let timer
  return function() {
    const th = this
    const args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function() {
      timer = null
      fn.apply(th, args)
    }, delay)
  }
}

/**
 * @description: 数字千位分隔
 * @author: tanxiaowen5
 * @Date: 2022-07-06 14:45:27
 * @return {*}
 */
export function numSeparated(num) {
  if (!num) return
  return num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}
